import React from 'react';
import { Util } from '../lib/util';
import { PreviewCompatibleImage } from './PreviewCompatibleImage';

interface OfferOptions {
  image: any;
  price: number;
  url: string;
}

interface OfferProps {
  title: string;
  headline: string;
  description: string;
  image: any;
  newOptions: OfferOptions[];
  usedOptions: OfferOptions[];
  gleenOptions: OfferOptions[];
}

const renderOffer = (
  image: any,
  price: number | string,
  url: string,
  index: number
) => {
  return (
    <div
      className="column is-narrow is-clickable"
      key={url}
      onClick={() => Util.openURL(url)}
    >
      <PreviewCompatibleImage
        imageInfo={{
          image,
          alt: `New Option ${index}`,
          style: { width: '48px', margin: 'auto' },
        }}
      />
      <div>
        {typeof price === 'number' ? Util.formatAsCurrency(price) : price}
      </div>
    </div>
  );
};

//      <div className="is-size-2 has-text-centered">{JSON.stringify(props)}</div>
export const Offer = (props: OfferProps) => {
  return (
    <div className="box">
      <div className="is-size-2 has-text-centered">{props.title}</div>
      <div className="columns is-vcentered">
        <div className="column is-one-third">
          <div className="box">
            <PreviewCompatibleImage
              imageInfo={{
                image: props.image,
                alt: `Offer ${props.title}`,
              }}
            />
          </div>
        </div>
        <div className="column is-two-thirds">
          <div className="is-size-5 has-text-centered">
            <strong>{props.headline}</strong>
          </div>
        </div>
      </div>
      <div className="is-size-6">{props.description}</div>
      <div className="columns">
        <div className="column">
          <div className="is-size-4 has-text-centered">New Options</div>
          <div className="columns is-mobile is-centered">
            {props.newOptions
              ? props.newOptions.map((newOption, index) => {
                  return renderOffer(
                    newOption.image,
                    newOption.price,
                    newOption.url,
                    index
                  );
                })
              : ''}
          </div>
        </div>
        <div className="column">
          <div className="is-size-4 has-text-centered">Used Options</div>
          <div className="columns is-mobile is-centered">
            {props.usedOptions
              ? props.usedOptions.map((usedOption, index) => {
                  return renderOffer(
                    usedOption.image,
                    usedOption.price,
                    usedOption.url,
                    index
                  );
                })
              : ''}
          </div>
        </div>
        <div className="column">
          <div className="is-size-4 has-text-centered">Honest Lease</div>
          <div className="columns is-mobile is-centered">
            {props.gleenOptions
              ? props.gleenOptions.map((gleenOption, index) => {
                  return renderOffer(
                    gleenOption.image,
                    Util.formatAsCurrency(gleenOption.price) + ' / month',
                    gleenOption.url,
                    index
                  );
                })
              : ''}
          </div>
        </div>
      </div>
    </div>
  );
};
